// Lightweight health-check API (polls /api/health)
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";

export interface HealthStatus { status: string }

export const healthApi = createApi({
  reducerPath: "healthApi",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // axios instance already prefixes /api
  endpoints: (builder) => ({
    fetchHealth: builder.query<HealthStatus, void>({
      query: () => ({ url: "/v1/health", method: "GET" }),
    }),
  }),
});

export const { useFetchHealthQuery } = healthApi;

